// Email validation
export const isValidEmail = (email) => {
  const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return regex.test(email);
};

// Required field validation
export const isRequired = (value) => {
  return value && value.toString().trim().length > 0;
};

// Min length validation
export const minLength = (value, min) => {
  return value && value.toString().length >= min;
};

// Max length validation
export const maxLength = (value, max) => {
  return value && value.toString().length <= max;
};

// Form validation helper
export const validateForm = (fields, rules) => {
  const errors = {};

  Object.keys(rules).forEach((field) => {
    const fieldRules = rules[field];
    const value = fields[field];

    fieldRules.forEach((rule) => {
      if (rule.type === 'required' && !isRequired(value)) {
        errors[field] = rule.message || 'This field is required';
      } else if (rule.type === 'email' && value && !isValidEmail(value)) {
        errors[field] = rule.message || 'Invalid email address';
      } else if (rule.type === 'minLength' && value && !minLength(value, rule.value)) {
        errors[field] = rule.message || `Minimum length is ${rule.value}`;
      } else if (rule.type === 'maxLength' && value && !maxLength(value, rule.value)) {
        errors[field] = rule.message || `Maximum length is ${rule.value}`;
      }
    });
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};